<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Subestoques'"
      :newRowmodalButtonText="'Novo Subestoque'"
      :tableHeader="headers"
      :tableRows="listaSubestoques"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      v-on:datatable-newrow="modalInsert"
      v-on:datatable-updaterow="modalUpdate"
      v-on:datatable-deleterow="modalDelete"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.modalSize"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="eventoDeAcao"
    >
    
      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="12">
              <AlertasModal
                :tipo="alertaModal.tipo"
                :texto="alertaModal.texto"
              ></AlertasModal>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSize.actualEdit.nomeSubestoque"
              name="nomeSubestoque"
              label="Nome do Subestoque"
              :rules="[rules.required, rules.limitCharacters]"
              counter="255"
              autocomplete="off"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSize.actualEdit.descricaoSubestoque"
              name="descricaoSubestoque"
              label="Descrição do Subestoque"
              counter="255"
              autocomplete="off"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>

    </ModalCustomSize>

    <DeleteItemModal
      :textModalDelete="customModalDelete.textModalDelete"
      :showModalDelete="customModalDelete.closeModal"
      :buttomTextModalDelete="'Excluir'"
      v-on:close-modal="customModalDelete.closeModal = false"
      v-on:on-response-modal-delete="deleteAction"
    ></DeleteItemModal>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "../components/DataTable2";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import DeleteItemModal from "../components/DeleteItemModal";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    DeleteItemModal,
    SkeletonTable,
    Alertas,
    AlertasModal
  },

  data: () => ({
    rules: {
      required: (value) => !!value || "Requer o campo!",
      limitCharacters: v => v && v.length <= 255 || 'Limite de 255 caracteres.'
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    customModalDelete: {
      numeroSubestoque: null,
      closeModal: null,
      textModalDelete: "Você realmente deseja deletar esse Subestoque?",
      descricaoTela: "Subestoque",
    },

    showSkeletonTable: true,
    loading: false,
    isFormValid: false,

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID Subestoque",
        value: "numeroSubestoque",
      },
      {
        text: "Nome do Subestoque",
        value: "nomeSubestoque",
      },
      {
        text: "Descrição do Subestoque",
        value: "descricaoSubestoque",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    modalCustomSize: {
      modalSize: "1080",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroEndereco: store.state.numeroEndereco,
        numeroSubestoque: null,
        nomeSubestoque: null,
        descricaoSubestoque: null,
        descricaoTela: "Subestoque"
      },
    },

    //Array populado pela função initialize
    listaSubestoques: [],
  }),

  created() {
    this.initialize();
  },

  watch: {
    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },
  },

  methods: {
    async initialize() {
      this.showSkeletonTable = true;
      try {
        this.erro = false;
        let response = await axios.put("subestoque", { numeroEndereco: store.state.numeroEndereco }, this.config);
        
        this.listaSubestoques = response.data;
        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error)
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
        this.showSkeletonTable = false;
      }
    },
    
    //#region Eventos de Ação e Requisição
    async eventoDeAcao() {
      this.modalCustomSize.isButtonsDisabled = true;
      try {
        if (this.modalCustomSize.isEdit) {
          await this.update(this.modalCustomSize.actualEdit);
        } else {
          await this.insert(this.modalCustomSize.actualEdit);
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.modalCustomSize.isButtonsDisabled = false;
        this.modalCustomSize.isOpen = false;
      }
    },

    async insert(reciveItem) {
      this.modalCustomSize.isLoadingRequestDisable = true;
      try {
        await axios.post("insertSubestoque", reciveItem, this.config);

        this.initialize();
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
      }
    },

    async update(reciveItem) {
      this.modalCustomSize.isLoadingRequestDisable = true;
      try {
        await axios.put("updateSubestoque", reciveItem, this.config);

        this.initialize();
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
      }
    },

    async deleteAction() {
      this.modalCustomSize.isLoadingRequestDisable = true;
      try {
        await axios.delete("subestoque", {
          data: this.customModalDelete,
          headers: this.config.headers,
        });

        this.initialize();
      } catch (error) {
        console.log(error)
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.customModalDelete.closeModal = false;
      }
    },
    //#endregion

    modalInsert() {
      this.loading = true

      this.modalCustomSize.actualEdit.nomeSubestoque = null;
      this.modalCustomSize.actualEdit.descricaoSubestoque = null;

      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.buttonText = "Concluir";
      this.modalCustomSize.formTitle = "Novo Subestoque";
      this.modalCustomSize.isOpen = true;
      this.loading = false
    },

    modalUpdate(item) {
      this.loading = true

      this.modalCustomSize.actualEdit.numeroSubestoque = item.numeroSubestoque;
      this.modalCustomSize.actualEdit.nomeSubestoque = item.nomeSubestoque;
      this.modalCustomSize.actualEdit.descricaoSubestoque = item.descricaoSubestoque;

      this.modalCustomSize.isEdit = true;
      this.modalCustomSize.buttonText = "Concluir";
      this.modalCustomSize.formTitle = "Atualizar Subestoque";
      this.modalCustomSize.isOpen = true;
      this.loading = false
    },

    modalDelete(item) {
      this.customModalDelete.numeroSubestoque = item.numeroSubestoque;
      this.customModalDelete.closeModal = true;
    },
  },
};
</script>